(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medicovi-benefits-tabs"] && !Shopify.designMode) return;
  try {
    
(function() {
  var tabs = document.querySelectorAll('.mv-btabs__tab-btn');
  var panels = document.querySelectorAll('.mv-btabs__panel');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      tabs.forEach(function(t) { t.setAttribute('aria-selected','false'); });
      panels.forEach(function(p) { p.setAttribute('aria-hidden','true'); });
      tab.setAttribute('aria-selected','true');
      var panelId = tab.getAttribute('aria-controls');
      document.getElementById(panelId).setAttribute('aria-hidden','false');
    });
    tab.addEventListener('keydown', function(e) {
      var idx = Array.from(tabs).indexOf(tab);
      if (e.key === 'ArrowRight') { tabs[(idx+1) % tabs.length].click(); tabs[(idx+1) % tabs.length].focus(); }
      if (e.key === 'ArrowLeft')  { tabs[(idx-1+tabs.length) % tabs.length].click(); tabs[(idx-1+tabs.length) % tabs.length].focus(); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medicovi-collection"] && !Shopify.designMode) return;
  try {
    
(function() {
  var activeTags = [];

  function getCards() {
    return document.querySelectorAll('.mv-col__card[data-tags]');
  }

  function applyFilter() {
    var cards = getCards();
    var visible = 0;
    cards.forEach(function(card) {
      var cardTags = card.getAttribute('data-tags').split('||');
      var match = activeTags.every(function(t) { return cardTags.indexOf(t) > -1; });
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    // Update count
    var countEl = document.querySelector('.mv-col__count');
    if (countEl) countEl.textContent = visible + ' produktů';
    // Update empty state
    var grid = document.querySelector('.mv-col__grid');
    var empty = grid && grid.querySelector('.mv-col__empty');
    if (visible === 0 && grid && !empty) {
      var p = document.createElement('div');
      p.className = 'mv-col__empty';
      p.style.cssText = 'grid-column:1/-1;text-align:center;padding:48px 20px;';
      p.innerHTML = '<p style="color:var(--mv-text-muted);font-size:1.5rem;margin:0 0 16px;">Pro tuto kombinaci filtrů nemáme přesný model.</p>'
        + '<a href="/pages/pomocnik-s-vyberem-vlozek" style="display:inline-flex;align-items:center;gap:8px;background:var(--mv-navy);color:white;padding:12px 24px;border-radius:999px;font-family:inherit;font-size:1.4rem;font-weight:800;text-decoration:none;">'
        + 'Nechte si poradit od Pomocníka výběru →</a>';
      grid.appendChild(p);
    } else if (visible > 0 && empty) {
      empty.remove();
    }
  }

  function renderActivePills() {
    var wrap = document.getElementById('mv-active-filters');
    if (!wrap) return;
    if (activeTags.length === 0) { wrap.style.display = 'none'; wrap.innerHTML = ''; return; }
    wrap.style.display = 'flex';
    wrap.innerHTML = activeTags.map(function(t) {
      return '<button class="mv-col__active-tag" data-mv-action="remove-tag" data-tag="' + t.replace(/"/g, '&quot;') + '">'
        + t + '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" width="12" height="12"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg></button>';
    }).join('') + '<button class="mv-col__active-tag" data-mv-action="clear-all" style="background:rgba(0,25,101,.3);">Zrušiť všetky <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" width="12" height="12"><path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12"/></svg></button>';
  }

  function updatePillStates() {
    document.querySelectorAll('.mv-col__pill[data-tag]').forEach(function(btn) {
      var tag = btn.getAttribute('data-tag');
      btn.classList.toggle('mv-col__pill--active', activeTags.indexOf(tag) > -1);
      var check = btn.querySelector('.mv-col__pill-check');
      if (check) check.style.opacity = activeTags.indexOf(tag) > -1 ? '1' : '0';
    });
    // Clear button
    var clearBtn = document.getElementById('mv-clear-all');
    if (clearBtn) clearBtn.classList.toggle('mv-col__filter-clear--visible', activeTags.length > 0);
    // FAB badge
    var badge = document.getElementById('mv-fab-badge');
    if (badge) {
      badge.textContent = activeTags.length;
      badge.classList.toggle('mv-col__filter-badge--visible', activeTags.length > 0);
    }
    // Group counts
    ['diag','usage','foot','shoe'].forEach(function(g) {
      var group = document.getElementById('mv-group-' + g);
      if (!group) return;
      var groupTags = Array.from(group.querySelectorAll('[data-tag]')).map(function(b) { return b.getAttribute('data-tag'); });
      var count = activeTags.filter(function(t) { return groupTags.indexOf(t) > -1; }).length;
      var countEl = group.previousElementSibling && group.previousElementSibling.querySelector('.mv-col__group-count');
      if (countEl) { countEl.textContent = count; countEl.classList.toggle('mv-col__group-count--active', count > 0); }
    });
  }

  // Count products per tag and update pill counts
  function updateTagCounts() {
    var cards = Array.from(getCards());
    document.querySelectorAll('.mv-col__pill[data-tag]').forEach(function(pill) {
      var tag = pill.getAttribute('data-tag');
      var count = cards.filter(function(c) {
        return c.getAttribute('data-tags').split('||').indexOf(tag) > -1;
      }).length;
      var countEl = pill.querySelector('.mv-col__pill-count');
      if (!countEl) {
        countEl = document.createElement('span');
        countEl.className = 'mv-col__pill-count';
        pill.appendChild(countEl);
      }
      countEl.textContent = count > 0 ? count : '';
    });
  }

  window.MvCol = {
    toggleTag: function(tag) {
      var idx = activeTags.indexOf(tag);
      if (idx > -1) { activeTags.splice(idx, 1); } else { activeTags.push(tag); }
      updatePillStates(); applyFilter(); renderActivePills();
    },
    removeTag: function(tag) {
      activeTags = activeTags.filter(function(t) { return t !== tag; });
      updatePillStates(); applyFilter(); renderActivePills();
    },
    clearAll: function() {
      activeTags = [];
      updatePillStates(); applyFilter(); renderActivePills();
    },
    sortChange: function(val) {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', val);
      window.location.href = url.toString();
    },
    toggleGroup: function(btn) {
      var panelId = btn.getAttribute('aria-controls');
      var panel = document.getElementById(panelId);
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      panel.hidden = expanded;
    },
    openModal: function() {
      var modal = document.getElementById('mv-filter-modal');
      if (!modal) return;
      modal.classList.add('mv-col__modal-overlay--open');
      document.body.style.overflow = 'hidden';
    },
    closeModal: function() {
      var modal = document.getElementById('mv-filter-modal');
      if (!modal) return;
      modal.classList.remove('mv-col__modal-overlay--open');
      document.body.style.overflow = '';
    },
    overlayClick: function(e) {
      if (e.target === document.getElementById('mv-filter-modal')) this.closeModal();
    },
    openSort: function() {
      var popup = document.getElementById('mv-sort-popup');
      var trigger = document.querySelector('[data-mv-action="open-sort"]');
      if (!popup) return;
      popup.classList.add('mv-col__sort-overlay--open');
      document.body.style.overflow = 'hidden';
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    },
    closeSort: function() {
      var popup = document.getElementById('mv-sort-popup');
      var trigger = document.querySelector('[data-mv-action="open-sort"]');
      if (!popup) return;
      popup.classList.remove('mv-col__sort-overlay--open');
      document.body.style.overflow = '';
      if (trigger) { trigger.setAttribute('aria-expanded', 'false'); trigger.focus(); }
    }
  };

  // ── Event delegation — replaces all inline onclick ──
  document.addEventListener('click', function(e) {
    var el = e.target.closest('[data-mv-action]');
    if (!el) return;
    var action = el.getAttribute('data-mv-action');

    if (action === 'open-modal')       { window.MvCol.openModal(); }
    if (action === 'close-modal')      { window.MvCol.closeModal(); }
    if (action === 'overlay-click')    { if (e.target === el) window.MvCol.closeModal(); }
    if (action === 'toggle-group')     { window.MvCol.toggleGroup(el); }
    if (action === 'toggle-tag')       { window.MvCol.toggleTag(el.getAttribute('data-tag')); }
    if (action === 'remove-tag')       { window.MvCol.removeTag(el.getAttribute('data-tag')); }
    if (action === 'clear-all')        { window.MvCol.clearAll(); }
    if (action === 'modal-apply')      { window.MvCol.closeModal(); }
    if (action === 'modal-reset')      { window.MvCol.clearAll(); }
    if (action === 'open-sort')        { window.MvCol.openSort(); }
    if (action === 'close-sort')       { window.MvCol.closeSort(); }
    if (action === 'sort-overlay-click') { if (e.target.id === 'mv-sort-popup') window.MvCol.closeSort(); }
    if (action === 'sort-select') {
      window.MvCol.sortChange(el.getAttribute('data-sort-value'));
      window.MvCol.closeSort();
    }
  });

  // Escape closes sort popup
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      var popup = document.getElementById('mv-sort-popup');
      if (popup && popup.classList.contains('mv-col__sort-overlay--open')) window.MvCol.closeSort();
    }
  });

  // Init on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateTagCounts);
  } else {
    updateTagCounts();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["medicovi-posture"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.mv-posture__hs').forEach(btn => {
  btn.addEventListener('click', () => {
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    document.querySelectorAll('.mv-posture__hs').forEach(b => b.setAttribute('aria-expanded','false'));
    btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
  });
});
document.addEventListener('click', e => {
  if (!e.target.closest('.mv-posture__hs') && !e.target.closest('.mv-posture__tooltip')) {
    document.querySelectorAll('.mv-posture__hs').forEach(b => b.setAttribute('aria-expanded','false'));
  }
});

  } catch(e) { console.error(e); }
})();
})();
